import { styled } from '@linaria/react';
import theme from '../../theme';

// Extract theme values for use in styled component
const selectedBackground = theme.colors.background.selected;
const hoverBackground = theme.colors.background.highlight.hover;
const tabsHeight = theme.constants.adminTabsHeight;

/**
 * Styled tabs container component that replaces the admin-tabs className
 * Provides a consistent tab styling across the application
 */
export const TabsContainer = styled.ul`
    display: flex !important;
    list-style: none !important;
    padding: 0 !important;
    margin: 0 !important;
    border-bottom: 1px solid #ddd !important;
    flex-wrap: nowrap !important;
    background: none !important;
    overflow: visible !important;
    height: ${tabsHeight} !important;
    flex-shrink: 0 !important;
    align-items: flex-end !important;

    @media print {
        display: none !important;
    }

    @media (max-width: 768px) {
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch;
        scroll-snap-type: x proximity;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }

        li {
            scroll-snap-align: start;
        }

        .tab-btn {
            padding: 0.4rem 0.5rem !important;
            font-size: 0.75rem !important;
        }
    }

    li {
        margin: 0 !important;
        flex-shrink: initial !important;
    }

    li.tab-right {
        margin-left: auto !important;
    }

    .tab-btn {
        display: block !important;
        padding: 0.6rem 0.7rem !important;
        background: #fff !important;
        border: 1px solid #ddd !important;
        border-bottom: none !important;
        color: #333 !important;
        text-decoration: none !important;
        cursor: pointer !important;
        border-radius: 4px 4px 0 0 !important;
        margin-right: 2px !important;
        transition: all 0.2s ease !important;
        font-size: 0.8rem !important;
        font-weight: 500 !important;
        white-space: nowrap !important;
        transform: none !important;
        box-shadow: none !important;

        &::before {
            display: none !important;
        }

        &:hover {
            background: ${hoverBackground} !important;
            color: #1976d2 !important;
            transform: none !important;
            box-shadow: none !important;
        }

        &.active {
            background: ${selectedBackground} !important;
            color: #1976d2 !important;
            border-color: #2196f3 !important;
            position: relative !important;
            z-index: 1 !important;
            transform: none !important;
            box-shadow: none !important;

            &::after {
                content: '' !important;
                position: absolute !important;
                bottom: -1px !important;
                left: 0 !important;
                right: 0 !important;
                height: 1px !important;
                background: ${selectedBackground} !important;
            }
        }
    }
`;
